import { render, staticRenderFns } from "./SupervisorsList.vue?vue&type=template&id=631f7970&scoped=true&"
import script from "./SupervisorsList.vue?vue&type=script&lang=js&"
export * from "./SupervisorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631f7970",
  null
  
)

export default component.exports